$(document).ready(function () {
  // Initialize Slick slider
  initializeRecommendProductSlider();
});

function initializeRecommendProductSlider() {
  const $slider = $('.recommend-product-slider');

  if (!$slider.hasClass('slick-initialized')) {
    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      speed: 300,
      lazyLoad: 'ondemand',
      prevArrow: $('.cart-slick-prev'),
      nextArrow: $('.cart-slick-next'),
      centerMode: true,
      centerPadding: '2.5rem',
      responsive: [
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            centerPadding: '8rem'
          }
        }
      ]
    });
  }
}

//Dropdown menu
document.addEventListener("DOMContentLoaded", function () {
  var menuItems = document.querySelectorAll(".list-menu .list-menu-item");

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  menuItems.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      // Remove 'active-menu' from all items
      menuItems.forEach(function (innerItem) {
        innerItem.classList.remove("active-menu");
      });

      // Add scrollbar compensation before setting overflow hidden
      const scrollBarWidth = getScrollbarWidth();
      document.body.style.paddingRight = `${scrollBarWidth}px`;
      document.body.style.overflow = 'hidden';
      document.body.classList.add('menu-main');

      // Activate hovered menu
      item.classList.add("active-menu");
    });

    item.addEventListener("mouseleave", function () {
      // Cleanup styles and classes
      item.classList.remove("active-menu");
      document.body.classList.remove('menu-main');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    });
  });
});


//Footer Accordian
// Account Producr Refernce
document.addEventListener('DOMContentLoaded', () => {
  // Check if .accordion-header elements exist
  const accordionHeaders = document.querySelectorAll('.footer-menu h5');

  if (accordionHeaders.length === 0) {
    return; // Exit early if no accordion headers are present
  }

  // Add click event to all headers
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function () {
      // Toggle active class on click
      if (this.classList.contains('active')) {
        this.classList.remove('active');
      } else {
        accordionHeaders.forEach(h => h.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });
});

// Mobile Menu
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.menu-drawer__menu li');
  items.forEach(li => {
    li.addEventListener('click', (e) => {
      if (e.target.closest('a')) return;

      const dropdown = li.querySelector('.nav-menu-dropdown');
      if (dropdown) {
        // console.log('clicked', li);
        dropdown.classList.toggle('active-submenu');
      }
    });
  });
});

//Video Play Pause Control Start
document.addEventListener('DOMContentLoaded', () => {
  const videoWrappers = document.querySelectorAll('.content-video');
  videoWrappers.forEach(wrapper => {
    const video = wrapper.querySelector('.my_video');
    const playButton = wrapper.querySelector('.play_button');
    const pauseButton = wrapper.querySelector('.pause_button');

    if (!video || !playButton || !pauseButton) {
      return;
    }

    playButton.addEventListener("click", function () {
      video.play();
      playButton.classList.add('vplay');
      pauseButton.classList.remove('vpause');
      pauseButton.classList.add('vpausedonhover');
      document.querySelector('html').classList.add('playvideo');
    });

    pauseButton.addEventListener("click", function () {
      video.pause();
      playButton.classList.remove('vplay');
      pauseButton.classList.remove('vpausedonhover');
      pauseButton.classList.add('vpause');
    });
  });
});

/* Blog Search */
$('.blog-search-btn').on('click', function () {
  $('.blog-search-form').toggle(); // toggle form visibility
  $(this).toggleClass('active');   // toggle active class
});

//Watch Shop Video
$(document).ready(function () {
  $('.shop-video-slider').each(function (index, element) {
    const $slider = $(element);
    const $container = $slider.closest('.slider-main-block');

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      speed: 300,
      lazyLoad: 'ondemand',
      prevArrow: $container.find('.shop-slick-prev'),
      nextArrow: $container.find('.shop-slick-next'),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '2.5rem',
          }
        }
      ]
    });
  });
});

document.querySelectorAll('.watch-video-product').forEach(el => {
  el.addEventListener('touchstart', function (e) {
    e.stopPropagation(); // prevent slick from hijacking the gesture
  }, { passive: true });
});

// tooltip for PDP page
$(document).ready(function () {
  const $tooltipContent = $('.tooltip-content');
  const $marqueeList = $('.rewards-marquee-list');
  let tooltipTimeout;

  $('.rewards-marquee-list li .tooltip-wrapper').hover(
    function () {
      clearTimeout(tooltipTimeout);

      const $hoveredLi = $(this);
      const offset = $hoveredLi.offset();
      const liHeight = $hoveredLi.outerHeight();

      $tooltipContent
        .css({
          left: (offset.left - 300) + 'px',
          position: 'absolute',
          display: 'flex',
        })
        .stop(true, true)
        .fadeIn(200);

      $marqueeList.addClass('paused');
    },
    function () {
      tooltipTimeout = setTimeout(function () {
        $tooltipContent.stop(true, true).fadeOut(200);
        $marqueeList.removeClass('paused');
      }, 200);
    }
  );

  // Keep tooltip open when hovered directly
  $tooltipContent.hover(
    function () {
      clearTimeout(tooltipTimeout);
    },
    function () {
      tooltipTimeout = setTimeout(function () {
        $tooltipContent.stop(true, true).fadeOut(200);
        $marqueeList.removeClass('paused');
      }, 200);
    }
  );
});

$(document).ready(function () {
  const $marqueeList = $('.rewards-marquee-list');

  // Add 'paused' class to ul when hovering any li
  $('.rewards-marquee-list li').hover(
    function () {
      $marqueeList.addClass('paused');
    },
    function () {
      $marqueeList.removeClass('paused');
    }
  );
});


// Video Play Pause Control Start
document.addEventListener('DOMContentLoaded', () => {
  const videoContainers = document.querySelectorAll('.product-video');

  videoContainers.forEach(container => {
    const video = container.querySelector('.my_video');
    const playButton = container.querySelector('.play_button');
    const pauseButton = container.querySelector('.pause_button');

    playButton.addEventListener("click", () => {
      video.play();
      playButton.classList.add('vplay');
      pauseButton.classList.remove('vpause');
      document.querySelector('html').classList.add('playvideo');
    });

    pauseButton.addEventListener("click", () => {
      video.pause();
      playButton.classList.remove('vplay');
      pauseButton.classList.add('vpause');
    });
  });
});

// Shoppable video play on click
document.addEventListener('DOMContentLoaded', function () {
  const videos = document.querySelectorAll(".watch-video-item");

  videos.forEach((video) => {
    // Ensure it's a video element
    if (!(video instanceof HTMLVideoElement)) return;

    // Click to play/pause and pause others
    video.addEventListener("click", () => {
      videos.forEach((v) => {
        if (v !== video && v instanceof HTMLVideoElement) {
          v.pause();
        }
      });

      if (video.paused) {
        video.play().catch(err => console.error("Play error:", err));
      } else {
        video.pause();
      }
    });
  });
});

/* first And last section add class */
document.addEventListener('DOMContentLoaded', function () {
  const shoppableSections = document.querySelectorAll('.shopify-section.shoppable-section');
  if (shoppableSections.length > 0) {
    shoppableSections[0].classList.add('shoppable-first');
    shoppableSections[shoppableSections.length - 1].classList.add('shoppable-last');
  }
});

// Account Script
const listItems = document.querySelectorAll('.heading-tab-list li a');
listItems.forEach((item) => {
  item.addEventListener('click', () => {
    // Remove 'active' from all
    listItems.forEach((li) => li.classList.remove('active'));
    // Add 'active' to clicked item
    item.classList.add('active');
  });
});
$(document).ready(function () {
  $('.heading-tab-list li').on('click', function () {
    var text = $(this).html();
    $('.default_option').html(text);
    $('.heading-tab-list li').show();
    $(this).hide();
    $('.faq-categories').removeClass('active');
  });

  // Hide the selected item on load
  var selected = $('.default_option').text().trim();
  $('.heading-tab-list li').each(function () {
    if ($(this).text().trim() === selected) {
      $(this).hide();
    }
  });

  // Toggle dropdown on click
  $('.default_option').on('click', function () {
    $(this).closest('.account-list-tab').toggleClass('active');
  });

  // Remove active class when an option is chosen
  $('.account-list-tab .heading-tab-item').on('click', function () {
    $(this).closest('.account-list-tab').removeClass('active');
  });
});
$(document).ready(function () {
  var $accordionMain = $('.order-accordion-main');

  // Open the first accordion on page load
  var $firstItem = $accordionMain.eq(0);
  $firstItem.addClass('active');
  $firstItem.find('.order-accordion-content').slideDown(300);

  $('.order-accordion-header').on('click', function (e) {
    e.preventDefault();

    var $thisHeader = $(this);
    var $thisMain = $thisHeader.closest('.order-accordion-main');
    var $content = $thisHeader.next('.order-accordion-content');

    if ($thisMain.hasClass('active')) {
      // If active, remove class from main div and slide up content
      $thisMain.removeClass('active');
      $content.stop(true, true).slideUp(400);
    } else {
      // Remove active class from all main divs and slide up all contents
      $accordionMain.removeClass('active');
      $('.order-accordion-content').stop(true, true).slideUp(400);

      // Add active class on this main div and slide down its content
      $thisMain.addClass('active');
      $content.stop(true, true).slideDown(400);
    }
  });
});

document.querySelectorAll('.heading-tab-item a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    const headerOffset = 110; // Adjust to your sticky header height
    const elementPosition = target.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  });
});

function formatCapitalizeText(selector) {
  $(selector).each(function () {
    var text = $(this).text()
      .replace(/([a-z])([A-Z])/g, '$1 $2')       // insert space before capital letters
      .toLowerCase()                             // convert all to lowercase
      .replace(/\b\w/g, function (char) {        // capitalize each word
        return char.toUpperCase();
      });

    $(this).text(text);
  });
}
formatCapitalizeText('.capitalize_text');

// recommend product popup
$(document).ready(function () {
    $('.quick-add__submit').on('click', function () {
    const $parent = $(this).closest('.recommend-product-block');
    if ($parent.length) {
      const ariaLabelledBy = $(this).attr('aria-labelledby');
      const match = ariaLabelledBy.match(/quick-add-(\d+)-submit/);

      if (match && match[1]) {
        const productId = match[1];
        const $modal = $(`#QuickAdd-${productId}`);
        if ($modal.length) {
          $modal.addClass('recommend-product-popup');

          const modalEl = $modal[0];
          const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                if (!modalEl.hasAttribute('open')) {
                  $modal.removeClass('recommend-product-popup');
                }
              }
            }
          });
          observer.observe(modalEl, { attributes: true });
        }
      }
    }
  });
});


$(document).on('click', '.popup-back-button', function () {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.open === 'function') {
    cartDrawer.open();
  }
  setTimeout(() => {
    const modalCloseBtn = $('[id^="ModalClose-"]'); 
    if (modalCloseBtn.length) {
      modalCloseBtn.click();
    }
  }, 200);

})